import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PcmpDepartmentDivisionsPage } from '@/features/pcmp/pages/PcmpDepartmentDivisionsPage';

export const Route = createFileRoute('/_auth/pcmp/department-divisions/')({
  component: () => (
    <ErrorBoundary moduleName="PCMP Division Mapping">
      <Suspense fallback={<PageLoader />}>
        <PcmpDepartmentDivisionsPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
